import { Empty, List, Space } from 'antd';
import React, { useContext, useEffect } from 'react';
import { BaseInfoContext } from '@/context/BaseInfoContext';
import AsyncWrapper from '@/components/AsyncWrapper';
import { OrderEndpoint, requestUserOrderList } from '@/models/order';
import {
  getOrderChannelDesc,
  getOrderStatusDesc,
  getOrderTypeDesc,
} from '../../pages/Order/helpers';
import PosButton from '../PosButton';
import Price from '../Price';
import dayjs from 'dayjs';
import { DateTimeShortFormat } from '@/models/common';
import {
  CheckCircleOutlined,
  FileAddTwoTone,
  PlusCircleFilled,
  PlusCircleOutlined,
  PlusCircleTwoTone,
  PlusOutlined,
} from '@ant-design/icons';

export type Props = {
  userId: number;
};

const UserOrderList: React.FC<Props> = ({ userId }: Props) => {
  const [, , helpers] = useContext(BaseInfoContext);
  const { payload, send: getCardUserList, loading, error } = requestUserOrderList();
  // const [detailOrderSn, setDetailOrderSn] = useState<string>(null);
  const request = (page = 1) => {
    getCardUserList({
      url: `${OrderEndpoint}/user/${userId}`,
      params: { limit: 3, page },
    }).then();
  };

  useEffect(() => {
    if (userId) {
      request(1);
    }
  }, [userId]);

  return (
    <>
      {/* <OrderDetailModal
        orderSn={detailOrderSn}
        onClose={hasChange => {
          if (hasChange) {
          }
          setDetailOrderSn(null);
        }}
      /> */}
      <AsyncWrapper loading={loading} error={error} render={!!payload}>
        {() => {
          const list = payload.list;
          const page = payload.page;
          if (!list || !list.length) {
            return <Empty description={'没有订单信息'} />;
          }
          return (
            <>
              <List
                loading={loading}
                itemLayout="horizontal"
                size={'small'}
                loadMore={
                  <div className={'align-flex-horizontal-center'} style={{ paddingTop: 15 }}>
                    <PosButton
                      disabled={page.current === 1}
                      loading={loading}
                      style={{ marginRight: 10 }}
                      onClick={() => {
                        request(page.current - 1);
                      }}>
                      上一页
                    </PosButton>
                    <PosButton
                      disabled={page.current === page.pages}
                      loading={loading}
                      style={{ marginLeft: 10 }}
                      onClick={() => {
                        request(page.current + 1);
                      }}>
                      下一页
                    </PosButton>
                  </div>
                }
                dataSource={list}
                renderItem={order => (
                  <List.Item
                    actions={[
                      <PosButton
                        key={'detail'}
                        onClick={() => {
                          // setDetailOrderSn(order.orderSn);
                          helpers.showOrderModal({
                            orderSn: order.orderSn,
                          });
                        }}>
                        详情
                      </PosButton>,
                    ]}>
                    <List.Item.Meta
                      title={
                        <>
                          <span style={{ display: 'inline-block' }}>订单号: {order.orderSn}</span>{' '}
                        </>
                      }
                      description={
                        <Space direction={'vertical'} size={5}>
                          <Space size={10}>
                            <div>
                              {getOrderChannelDesc(order)} {getOrderTypeDesc(order)}{' '}
                              {getOrderStatusDesc(order)}
                            </div>
                            <Price value={order.actualPrice} />
                          </Space>
                          <Space size={15} split={<>|</>}>
                            <div>下单: {dayjs(order.addTime).format(DateTimeShortFormat)}</div>
                            {order.endTime ? (
                              <div>关单: {dayjs(order.endTime).format(DateTimeShortFormat)}</div>
                            ) : null}
                          </Space>
                        </Space>
                      }
                    />
                  </List.Item>
                )}
              />
            </>
          );
        }}
      </AsyncWrapper>
    </>
  );
};

export default UserOrderList;
